import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-relocation-referral-popup',
  templateUrl: './relocation-referral-popup.component.html',
  styleUrls: ['./relocation-referral-popup.component.scss']
})
export class RelocationReferralPopupComponent implements OnInit {
  head: any;
  relocationPromotionLink: any;

  constructor(

    public dialogRef: MatDialogRef<RelocationReferralPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public value: any,
    private toastr: ToastrService,
    private navigationService: NavigationService,


  ) { }

  ngOnInit(): void {

    this.head = this.value.title
    this.relocationPromotionLink = this.value.data

  }
  copyLink(): void {
    navigator.clipboard.writeText(this.relocationPromotionLink).then(() => {
      this.toastr.success('Link copied to clipboard!');
    });
  }
  Close() {
    this.dialogRef.close()
    this.navigationService.goTomanageRelocationPromotion();
  }

}
